import React from 'react';
import { Link } from 'react-router-dom';

import { RenderFaq } from 'feature/account/HBPoint/LandingPage';
import { TNC, TNC_DESCRIPTION } from 'hb-redux-store/constants/halalboxPrime';

import './membership-terms-and-condition.scss';

// constant
const WHITE_COLOR = '#fff';

const MembershipTermsAndCondition = ({ data, tncTitle }) => (
  <>
    <div className="separator" />
    <span className="terms-and-condition title">{tncTitle}</span>
    <div className="terms-and-condition--faq-container">
      <RenderFaq faq={data} color={WHITE_COLOR} blackIcon={false} />
    </div>
  </>
);

export default MembershipTermsAndCondition;
